module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst attributes = (resourceData.data || {}).attributes || {}\nconst statusFlagsSummary = attributes.statusFlagsSummary || {}\nconst severities = statusFlagsSummary.severities || {}\nconst maxSeverity = statusFlagsSummary.maxSeverity || 'ok'\n// set title\nlet title = ''\nconst titleParts = []\nfor(const severity of ['error', 'warning', 'info']){\nconst entityReasonSeverityTypes = (severities[severity] || {}).entityReasonSeverityTypes || []\nif(entityReasonSeverityTypes.length > 0){\ntitleParts.push(`${storage.__(`statusFlags.severity.${severity}`)}:\\n${entityReasonSeverityTypes.map(entityReasonSeverityType => ` - ${storage.__(`statusFlags:${entityReasonSeverityType}`)}`).join('\\n')}`)\n}\n}\nif(titleParts.length > 0){\ntitle = titleParts.join('\\n\\n')\n}\n// set additional classes\nconst additionalClasses = [`severity_${maxSeverity}`]\n// set additional attributes\nconst additionalAttributes = []\nif(additionalClasses.length > 0){\nadditionalAttributes.push(`class=\"${additionalClasses.join(' ')}\"`)\n}\nif(title){\nadditionalAttributes.push(`title=\"${title}\"`)\n}\n%><div <%- additionalAttributes.join(' ') %>><%\n%><div class=\"statusSymbol\"><%\n%><i class=\"fi fi-severity-<%- maxSeverity %>\"></i><%\n%></div><%\n%><div class=\"statusCounter\"><%\n%><div class=\"count\"><%= (severities.ok || {}).nrOfElements || 0 %> / <%= statusFlagsSummary.all || 0 %></div><%\n%></div><%\n%></div>"
  , __filename = "components/templates/core/statusFlagsSummary/statusFlagsSummary.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const attributes = (resourceData.data || {}).attributes || {}
const statusFlagsSummary = attributes.statusFlagsSummary || {}
const severities = statusFlagsSummary.severities || {}
const maxSeverity = statusFlagsSummary.maxSeverity || 'ok'
// set title
let title = ''
const titleParts = []
for(const severity of ['error', 'warning', 'info']){
const entityReasonSeverityTypes = (severities[severity] || {}).entityReasonSeverityTypes || []
if(entityReasonSeverityTypes.length > 0){
titleParts.push(`${storage.__(`statusFlags.severity.${severity}`)}:\n${entityReasonSeverityTypes.map(entityReasonSeverityType => ` - ${storage.__(`statusFlags:${entityReasonSeverityType}`)}`).join('\n')}`)
}
}
if(titleParts.length > 0){
title = titleParts.join('\n\n')
}
// set additional classes
const additionalClasses = [`severity_${maxSeverity}`]
// set additional attributes
const additionalAttributes = []
if(additionalClasses.length > 0){
additionalAttributes.push(`class="${additionalClasses.join(' ')}"`)
}
if(title){
additionalAttributes.push(`title="${title}"`)
}

    ; __line = 28
    ; __append("<div ")
    ; __append( additionalAttributes.join(' ') )
    ; __append(">")
    ; 

    ; __line = 29
    ; __append("<div class=\"statusSymbol\">")
    ; 

    ; __line = 30
    ; __append("<i class=\"fi fi-severity-")
    ; __append( maxSeverity )
    ; __append("\"></i>")
    ; 

    ; __line = 31
    ; __append("</div>")
    ; 

    ; __line = 32
    ; __append("<div class=\"statusCounter\">")
    ; 

    ; __line = 33
    ; __append("<div class=\"count\">")
    ; __append(escapeFn( (severities.ok || {}).nrOfElements || 0 ))
    ; __append(" / ")
    ; __append(escapeFn( statusFlagsSummary.all || 0 ))
    ; __append("</div>")
    ; 

    ; __line = 34
    ; __append("</div>")
    ; 

    ; __line = 35
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/statusFlagsSummary/statusFlagsSummary.ejs

}